const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentSold } from './MomentSold';

export class RealizedGains extends BaseObject {
  public account: Account = null
  public moments: MomentSold[] = null
  public saleValue: number = null
  public costBasis: number = null
  public numMoments: number = null
  public computedDate: Date = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.account) this.account = new Account(this.account)
    if (this.moments) this.moments = this.moments.map((po) => new MomentSold(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }

  public isSafe(): boolean {
    return true
  }

  public getNiceGainString(): string {
    const numericalGain: number = this.saleValue - this.costBasis
    const nice: string = `Realized ${ numericalGain < 0 ? 'loss of ' : 'gain of '}$${Math.round(Math.abs(numericalGain)).toLocaleString()}`
    return nice
  }
  public getGainClass(): string {
    if (this.saleValue >= this.costBasis) return 'positive'
    return 'negative'
  }
  public getFriendlyName(): string {
    if (!this.account) return "The user"
    return this.account.username || '0x' + this.account.flowAddress
  }


}




(async () => {
})();
